module.exports = __webpack_public_path__ + "img/summer-2.d4ba28e2.jpg";